import { Vue, Prop, Component } from "@wagich/vue-facing-decorator-metadata";
import Flickity from "flickity";

import { render } from "./event-timeline.html";
import { type TimelineShowModel } from "../models/Events";

@Component({
	render,
})
export class EventTimeline extends Vue {
	@Prop({ default: () => [] })
	shows: TimelineShowModel[];

	@Prop({ default: false })
	isClosestShowBeforeToday: boolean;

	isVisible: boolean = false;
	private flickity: Flickity | null = null;

	getDelay(index: number) {
		return { transitionDelay: `${index * 200}ms` };
	}

	async mounted() {
		await this.$nextTick();

		const list = this.$refs.list as HTMLElement;
		this.flickity = new Flickity(list, {
			cellSelector: ".timeline-event",
			cellAlign: "left",
			contain: true,
			setGallerySize: false,
			freeScroll: true,
			prevNextButtons: true,
			pageDots: false
		});


		this.isVisible = true;
		await this.$nextTick();
		// Force a re-measure once the carousel exists, in case widths changed
		// between construction and the next paint.
		this.flickity.resize();

		const cells = list.querySelectorAll<HTMLElement>(".timeline-event");
		const todayIndex = Array.from(cells).findIndex(el => el.classList.contains("today"));
		window.setTimeout(() => {
			this.flickity?.resize();
			this.flickity?.select(Math.max(todayIndex - 1, 0));
		}, Math.max(todayIndex, 0) * 200);
	}

	beforeUnmount() {
		this.flickity?.destroy();
		this.flickity = null;
	}
}
